import { blogData } from "../data/blogData";
import "../styles/blogSection.css";

const BlogSection = () => {
  return (
    <section id="blog-publications" className="blog-section">
      <h2 className="reveal">Publications & Certification</h2>

      {blogData.length > 0 ? (
        <div className="blog-list">
          {blogData.map((blog) => (
            <a
              key={blog.id}
              href={blog.link}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-list-item reveal"
            >
              <div className="blog-info">
                {blog.tag && <span className="blog-tag">{blog.tag}</span>}
                <h3 className="blog-title">{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <span className="blog-date">
                  <i className="far fa-calendar-alt"></i> {blog.date}
                  {blog.publication && (
                    <>
                      <span className="separator"> | </span>
                      <span className="blog-publication">
                        {blog.publication}
                      </span>
                    </>
                  )}
                </span>
              </div>
              <div className="blog-link-icon">
                <i className="fas fa-arrow-right"></i>{" "}
                {/* Or fa-external-link-alt */}
              </div>
            </a>
          ))}
        </div>
      ) : (
        <p className="no-blogs-message">
          No blogs or publications to display yet. Check back soon!
        </p>
      )}
    </section>
  );
};

export default BlogSection;
